import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  apSuppliers: {
    allSuppliersIds: [],
    data: [],
    research_data: [],
    currentPage: 1,
    totalPages: 0,
    totalCount: 0,
  },
  webBasedSuppliers: { list: [[], [], []], currentPage: 1, totalPages: 0, totalCount: 0 },
  externalSuppliers: { list: [], currentPage: 1, totalPages: 0, totalCount: 0 },
  searchQuery: '',
}
export const supplierIntelligence = createSlice({
  name: 'supplierIntelligence',
  initialState,
  reducers: {
    setSearchData: (state, action) => {
      state.apSuppliers = action.payload.apSuppliers
      state.webBasedSuppliers = action.payload.webBasedSuppliers
      state.externalSuppliers = action.payload.externalSuppliers
      state.searchQuery = action.payload.searchQuery
    },
  },
})

export const { setSearchData } = supplierIntelligence.actions
export default supplierIntelligence.reducer
